<template>
  <div>
    <v-dialog v-model="show" persistent max-width="50%">
      <v-card>
        <v-app-bar text color="secondary">
          <page-header-title :title="$t('logs.details')"></page-header-title>
        </v-app-bar>

        <v-divider></v-divider>

        <v-card-text class="py-0 mt-4">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">{{ $t("logs.field") }}</th>
                  <th class="text-left">{{ $t("logs.before_values") }}</th>
                  <th class="text-left">{{ $t("logs.after_values") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, column) in logDetails" :key="column">
                  <td>
                    {{ column }}
                  </td>
                  <td>{{ item.before }}</td>
                  <td>{{ item.after }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <action-button type="back" @click="cancel()" small />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "LogDetailPopup",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      url: "",

      log: {},

      logDetails: []
    }
  },

  created() {
    if (this.id) {
      this.get(this.id)
    }
  },

  methods: {
    get(id) {
      axios
        .get(this.API_URL + "log/" + id)
        .then((res) => {
          let before = res.data.data.before_value ? JSON.parse(res.data.data.before_value) : []
          let after = res.data.data.after_value ? JSON.parse(res.data.data.after_value) : []
          let fields = {}

          for (const [key, value] of Object.entries(before)) {
            if (!fields.hasOwnProperty(key)) {
              fields[key] = {
                before: null,
                after: null
              }
            }

            fields[key].before = value
          }

          for (const [key, value] of Object.entries(after)) {
            if (!fields.hasOwnProperty(key)) {
              fields[key] = {
                before: null,
                after: null
              }
            }

            fields[key].after = value
          }

          this.logDetails = fields
        })
        .catch((err) => console.log(err))
    },

    cancel() {
      this.$emit("callback_logdetailpopup_cancel")
    }
  }
}
</script>

<style scoped></style>
